module.exports = __webpack_public_path__ + "media/images/bleibtbunt_logo_negativ-4f51f8ab4ad1bba64a4f7be16de716bc.png";